'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var CartDetailStepBase = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(CartDetailStepBase, _React$Component);

    function CartDetailStepBase(props, step) {
        (0, _classCallCheck3.default)(this, CartDetailStepBase);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStepBase.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStepBase)).call(this, props));

        _this.step = step;
        _this.state = {
            loading: false
        };
        return _this;
    }

    (0, _createClass3.default)(CartDetailStepBase, [{
        key: 'nextStep',
        value: function nextStep() {
            this.props.setStep(this.step + 1);
            (0, _linksoftAlbatros.scrollToTop)();

            // scroll to step2
            if (this.step === 1 && (0, _linksoftAlbatros.isMaxWidth)('sm')) {
                setTimeout(function () {
                    (0, _linksoftAlbatros.scrollTo)('.cart__step--2', 30);
                }, 600);
            }

            // display step 3 and on 'md' screen
            if (this.step === 2 && (0, _linksoftAlbatros.isMaxWidth)('md')) {
                setTimeout(function () {
                    (0, _linksoftAlbatros.scrollTo)('.cart__step--3', 30);
                }, 600);
            }
        }
    }, {
        key: 'goToStep',
        value: function goToStep() {
            this.props.setStep(this.step);
            (0, _linksoftAlbatros.scrollToTop)();

            // scroll back to step1
            if (this.step === 1) {
                // trigger window resize event for reinit slick-react carousel
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 600);
            }
            if (this.step === 1 && (0, _linksoftAlbatros.isMaxWidth)('sm')) {
                setTimeout(function () {
                    (0, _linksoftAlbatros.scrollTo)('.cart', 30);
                }, 600);
            }

            // scroll back to step2
            if (this.step === 2 && (0, _linksoftAlbatros.isMaxWidth)('sm')) {
                setTimeout(function () {
                    (0, _linksoftAlbatros.scrollTo)('.cart__step--2', 30);
                }, 600);
            }
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.props.cart.step === this.step;
        }

        /**
         * True if it is one of the previous steps
         */

    }, {
        key: 'isPrevious',
        value: function isPrevious(newProps) {
            return this.step < (newProps || this.props).cart.step;
        }
    }, {
        key: 'isPreviousUpdated',
        value: function isPreviousUpdated(prevProps) {
            return prevProps < this.props.cart.step;
        }
    }, {
        key: 'setLoading',
        value: function setLoading(isLoading) {
            this.setState((0, _extends3.default)({}, this.state, { loading: isLoading }));
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this.state.loading;
        }
    }, {
        key: 'stepClass',
        value: function stepClass() {
            var c = 'cart__step cart__step--' + this.step;
            if (this.isActive()) {
                c += ' cart__step--active';
            } else {
                c += ' cart__step--passive';
            }
            if (this.isLoading()) {
                c += ' step__loading';
            }
            return c;
        }
    }, {
        key: 'asideClass',
        value: function asideClass() {
            var c = 'cart__aside cart__aside--' + this.step;
            if (!this.isActive()) {
                c += ' cart__aside--hide';
            }
            return c;
        }
    }, {
        key: 'freeDelivery',
        value: function freeDelivery() {
            var msg = { active: false, text: null };
            var _props$cart = this.props.cart,
                limit = _props$cart.minOrderPriceForFreeDelivery,
                totalProductsPrice = _props$cart.totalProductsPrice;

            if (typeof limit === 'number') {
                var toReachBonus = limit - totalProductsPrice.finalPrice;
                if (toReachBonus > 0) {
                    msg.text = (0, _linksoftAlbatros.stringFormat)(Resx.App.BuyMoreForAndYouWillHaveShippingForFreeMessage, (0, _linksoftAlbatros.formatPrice)(limit, _linksoftAlbatros.PriceType.CartTotalPrice));
                } else {
                    msg.text = Resx.App.YouHaveFreeTransportation;
                    msg.active = true;
                }
            }
            return msg;
        }
    }, {
        key: 'possibleFreeDelivery',
        value: function possibleFreeDelivery() {
            return _utils2.default.formatPossibleFreeDelivery(this.props.cart);
        }
    }, {
        key: 'freeProducts',
        value: function freeProducts() {
            var msg = { active: false, text: null };
            var _props$cart2 = this.props.cart,
                limit = _props$cart2.minOrderPriceForFreeProducts,
                totalProductsPrice = _props$cart2.totalProductsPrice;

            if (typeof limit === 'number') {
                var toReachBonus = limit - totalProductsPrice.finalPrice;
                if (toReachBonus > 0) {
                    msg.text = (0, _linksoftAlbatros.stringFormat)(Resx.App.BuyMoreForAndYouWillHaveGiftForFreeMessage, (0, _linksoftAlbatros.formatPrice)(limit, _linksoftAlbatros.PriceType.CartTotalPrice));
                } else {
                    msg.text = Resx.App.YouHaveFreeProduct;
                    msg.active = true;
                }
            }
            return msg;
        }
    }]);
    return CartDetailStepBase;
}(_react2.default.Component), _class.propTypes = {
    cart: _propTypes2.default.object.isRequired,
    empty: _propTypes2.default.func.isRequired,
    setStep: _propTypes2.default.func.isRequired
}, _temp);
exports.default = CartDetailStepBase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/StepBase.js
// module id = 567
// module chunks = 0